import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
import { AuthService } from '../core/auth.service';
import { NavigationService } from '../core/navigation.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(private auth_service: AuthService, private navigation_service: NavigationService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.auth_service.isAuthenticated().pipe(
      map(e => {
        if (e) {
          return true;
        } else {
          this.navigation_service.toAuthSignin();
          return false;
        }
      }),
    );
  }
}
